module.exports = __webpack_public_path__ + "img/mnemomozg-mob.567b8662.jpg";